import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    transition: max-height 0.4s ease;\n    overflow: none;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    cursor: pointer;\n    p:first-child{\n        margin:0;\n        color:#CEAB7D;\n        font-weight:bold;\n    }\n    p:last-child{\n        margin:0;\n        color:white;\n    }\n    padding:25px;\n    background:#143645;\n    display:flex;\n    height:100%;\n    >div{\n        &:first-child{\n            width:90%;\n        }\n        &:last-child{\n            width:10%;\n            align-content:center;\n            text-align:right;\n            i{\n                color:white;\n                padding:0;\n                line-height:1.2;\n                font-size:40px;\n            }\n        }\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    .none{\n        max-height: 0px;\n        overflow: hidden;\n    }\n    .open{\n        max-height: 1000px;\n        overflow: none;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
export var StyledWrapper = styled.div(_templateObject());
export var StyledTitle = styled.div(_templateObject2());
export var StyledContent = styled.div(_templateObject3());